// This file is AUTOGENERATED, do not edit it manually!!!

import { taskDetails as taskDetailsde } from './taskDetailsResx.de';
import { taskDetails as taskDetailsen } from './taskDetailsResx.en';
import { taskDetails as taskDetailsen_risk } from './taskDetailsResx.en_risk';
import { taskDetails as taskDetailses } from './taskDetailsResx.es';
import { taskDetails as taskDetailsfr } from './taskDetailsResx.fr';
import { taskDetails as taskDetailsit } from './taskDetailsResx.it';
import { taskDetails as taskDetailsnl } from './taskDetailsResx.nl';
import { taskDetails as taskDetailspl } from './taskDetailsResx.pl';
import { taskDetails as taskDetailspt } from './taskDetailsResx.pt';
import { taskDetails as taskDetailsru } from './taskDetailsResx.ru';
import { taskDetails as taskDetailssk } from './taskDetailsResx.sk';
import { taskDetails as taskDetailssv } from './taskDetailsResx.sv';
import { taskDetails as taskDetailstr } from './taskDetailsResx.tr';

const langMap: { [k: string]: Partial<typeof taskDetailsen> } = {
    de: taskDetailsde,
    en: taskDetailsen,
    en_risk: taskDetailsen_risk,
    es: taskDetailses,
    fr: taskDetailsfr,
    it: taskDetailsit,
    nl: taskDetailsnl,
    pl: taskDetailspl,
    pt: taskDetailspt,
    ru: taskDetailsru,
    sk: taskDetailssk,
    sv: taskDetailssv,
    tr: taskDetailstr,
};

/* tslint:disable: max-line-length */
export const taskDetailsResx = {
    get actualCompletionDate() {
        return langMap[ep.resxCulture].actualCompletionDate || langMap.en.actualCompletionDate;
    },
    get actualCompletionDateFull() {
        return langMap[ep.resxCulture].actualCompletionDateFull || langMap.en.actualCompletionDateFull;
    },
    get AutoAssign_Issue() {
        return langMap[ep.resxCulture].AutoAssign_Issue || langMap.en.AutoAssign_Issue;
    },
    get AutoAssign_Note() {
        return langMap[ep.resxCulture].AutoAssign_Note || langMap.en.AutoAssign_Note;
    },
    get AutoAssign_Request() {
        return langMap[ep.resxCulture].AutoAssign_Request || langMap.en.AutoAssign_Request;
    },
    get AutoAssign_Task() {
        return langMap[ep.resxCulture].AutoAssign_Task || langMap.en.AutoAssign_Task;
    },
    get AutoAssign_Title() {
        return langMap[ep.resxCulture].AutoAssign_Title || langMap.en.AutoAssign_Title;
    },
    get BaselineCapturedFeedback() {
        return langMap[ep.resxCulture].BaselineCapturedFeedback || langMap.en.BaselineCapturedFeedback;
    },
    get BaselineCaptureLabel() {
        return langMap[ep.resxCulture].BaselineCaptureLabel || langMap.en.BaselineCaptureLabel;
    },
    get BaselineOverwrite() {
        return langMap[ep.resxCulture].BaselineOverwrite || langMap.en.BaselineOverwrite;
    },
    get BaselineOverwriteDescription() {
        return langMap[ep.resxCulture].BaselineOverwriteDescription || langMap.en.BaselineOverwriteDescription;
    },
    get BaselineOverwrittenFeedback() {
        return langMap[ep.resxCulture].BaselineOverwrittenFeedback || langMap.en.BaselineOverwrittenFeedback;
    },
    get BaselineRecaptureLabel() {
        return langMap[ep.resxCulture].BaselineRecaptureLabel || langMap.en.BaselineRecaptureLabel;
    },
    get BaselineSuccess() {
        return langMap[ep.resxCulture].BaselineSuccess || langMap.en.BaselineSuccess;
    },
    get Billed() {
        return langMap[ep.resxCulture].Billed || langMap.en.Billed;
    },
    get Billing() {
        return langMap[ep.resxCulture].Billing || langMap.en.Billing;
    },
    get BillingSettingsTitle() {
        return langMap[ep.resxCulture].BillingSettingsTitle || langMap.en.BillingSettingsTitle;
    },
    get BillingTypeNotBillable() {
        return langMap[ep.resxCulture].BillingTypeNotBillable || langMap.en.BillingTypeNotBillable;
    },
    get BillingTypeProjectBillingSettings() {
        return langMap[ep.resxCulture].BillingTypeProjectBillingSettings || langMap.en.BillingTypeProjectBillingSettings;
    },
    get btnNotifications() {
        return langMap[ep.resxCulture].btnNotifications || langMap.en.btnNotifications;
    },
    get BudgetLeft() {
        return langMap[ep.resxCulture].BudgetLeft || langMap.en.BudgetLeft;
    },
    get BudgetTotal() {
        return langMap[ep.resxCulture].BudgetTotal || langMap.en.BudgetTotal;
    },
    get By() {
        return langMap[ep.resxCulture].By || langMap.en.By;
    },
    get Change() {
        return langMap[ep.resxCulture].Change || langMap.en.Change;
    },
    get Close() {
        return langMap[ep.resxCulture].Close || langMap.en.Close;
    },
    get ConfirmStatusDialogTitle() {
        return langMap[ep.resxCulture].ConfirmStatusDialogTitle || langMap.en.ConfirmStatusDialogTitle;
    },
    get CreateInvoice_Title() {
        return langMap[ep.resxCulture].CreateInvoice_Title || langMap.en.CreateInvoice_Title;
    },
    get DayPluralFormat() {
        return langMap[ep.resxCulture].DayPluralFormat || langMap.en.DayPluralFormat;
    },
    get Days() {
        return langMap[ep.resxCulture].Days || langMap.en.Days;
    },
    get DeleteActivity() {
        return langMap[ep.resxCulture].DeleteActivity || langMap.en.DeleteActivity;
    },
    get DeleteProject() {
        return langMap[ep.resxCulture].DeleteProject || langMap.en.DeleteProject;
    },
    get Dependencies_Count() {
        return langMap[ep.resxCulture].Dependencies_Count || langMap.en.Dependencies_Count;
    },
    get DifferPermissionsMessage() {
        return langMap[ep.resxCulture].DifferPermissionsMessage || langMap.en.DifferPermissionsMessage;
    },
    get Disable_Dates_Rollup() {
        return langMap[ep.resxCulture].Disable_Dates_Rollup || langMap.en.Disable_Dates_Rollup;
    },
    get Disable_Dates_Rollup_Feedback() {
        return langMap[ep.resxCulture].Disable_Dates_Rollup_Feedback || langMap.en.Disable_Dates_Rollup_Feedback;
    },
    get DueIn_Ok() {
        return langMap[ep.resxCulture].DueIn_Ok || langMap.en.DueIn_Ok;
    },
    get DueIn_Trouble() {
        return langMap[ep.resxCulture].DueIn_Trouble || langMap.en.DueIn_Trouble;
    },
    get DueIn_Warning() {
        return langMap[ep.resxCulture].DueIn_Warning || langMap.en.DueIn_Warning;
    },
    get EditRoleAndPermissions() {
        return langMap[ep.resxCulture].EditRoleAndPermissions || langMap.en.EditRoleAndPermissions;
    },
    get Enable_And_Reschedule() {
        return langMap[ep.resxCulture].Enable_And_Reschedule || langMap.en.Enable_And_Reschedule;
    },
    get Enable_Dates_Rollup() {
        return langMap[ep.resxCulture].Enable_Dates_Rollup || langMap.en.Enable_Dates_Rollup;
    },
    get Enable_Dates_Rollup_Description() {
        return langMap[ep.resxCulture].Enable_Dates_Rollup_Description || langMap.en.Enable_Dates_Rollup_Description;
    },
    get Enable_Dates_Rollup_Feedback() {
        return langMap[ep.resxCulture].Enable_Dates_Rollup_Feedback || langMap.en.Enable_Dates_Rollup_Feedback;
    },
    get Enable_Dates_Rollup_Title() {
        return langMap[ep.resxCulture].Enable_Dates_Rollup_Title || langMap.en.Enable_Dates_Rollup_Title;
    },
    get endDate() {
        return langMap[ep.resxCulture].endDate || langMap.en.endDate;
    },
    get endDateFull() {
        return langMap[ep.resxCulture].endDateFull || langMap.en.endDateFull;
    },
    get endLessThenStartMsg() {
        return langMap[ep.resxCulture].endLessThenStartMsg || langMap.en.endLessThenStartMsg;
    },
    get estimatedHours() {
        return langMap[ep.resxCulture].estimatedHours || langMap.en.estimatedHours;
    },
    get ExportToMsProject() {
        return langMap[ep.resxCulture].ExportToMsProject || langMap.en.ExportToMsProject;
    },
    get Fields() {
        return langMap[ep.resxCulture].Fields || langMap.en.Fields;
    },
    get FillCustomFields() {
        return langMap[ep.resxCulture].FillCustomFields || langMap.en.FillCustomFields;
    },
    get Follow() {
        return langMap[ep.resxCulture].Follow || langMap.en.Follow;
    },
    get follow_all_activities_label() {
        return langMap[ep.resxCulture].follow_all_activities_label || langMap.en.follow_all_activities_label;
    },
    get hide_checklist_label() {
        return langMap[ep.resxCulture].hide_checklist_label || langMap.en.hide_checklist_label;
    },
    get HideCustomFields() {
        return langMap[ep.resxCulture].HideCustomFields || langMap.en.HideCustomFields;
    },
    get hoursLeft() {
        return langMap[ep.resxCulture].hoursLeft || langMap.en.hoursLeft;
    },
    get HoursOf() {
        return langMap[ep.resxCulture].HoursOf || langMap.en.HoursOf;
    },
    get HtmlField_ReadAll() {
        return langMap[ep.resxCulture].HtmlField_ReadAll || langMap.en.HtmlField_ReadAll;
    },
    get ImDoneText() {
        return langMap[ep.resxCulture].ImDoneText || langMap.en.ImDoneText;
    },
    get invoice_creation_no_customer_disabled_reason() {
        return langMap[ep.resxCulture].invoice_creation_no_customer_disabled_reason || langMap.en.invoice_creation_no_customer_disabled_reason;
    },
    get IsMilestone() {
        return langMap[ep.resxCulture].IsMilestone || langMap.en.IsMilestone;
    },
    get issue() {
        return langMap[ep.resxCulture].issue || langMap.en.issue;
    },
    get MarkAsMilestone() {
        return langMap[ep.resxCulture].MarkAsMilestone || langMap.en.MarkAsMilestone;
    },
    get MemberPermission_Add() {
        return langMap[ep.resxCulture].MemberPermission_Add || langMap.en.MemberPermission_Add;
    },
    get MemberPermission_Add_For_Someone_Else() {
        return langMap[ep.resxCulture].MemberPermission_Add_For_Someone_Else || langMap.en.MemberPermission_Add_For_Someone_Else;
    },
    get MemberPermission_Add_Own() {
        return langMap[ep.resxCulture].MemberPermission_Add_Own || langMap.en.MemberPermission_Add_Own;
    },
    get MemberPermission_CanEditActualExpenses() {
        return langMap[ep.resxCulture].MemberPermission_CanEditActualExpenses || langMap.en.MemberPermission_CanEditActualExpenses;
    },
    get MemberPermission_CanEditPlannedExpenses() {
        return langMap[ep.resxCulture].MemberPermission_CanEditPlannedExpenses || langMap.en.MemberPermission_CanEditPlannedExpenses;
    },
    get MemberPermission_CanLogExpenses() {
        return langMap[ep.resxCulture].MemberPermission_CanLogExpenses || langMap.en.MemberPermission_CanLogExpenses;
    },
    get MemberPermission_CanManageProjectMembers() {
        return langMap[ep.resxCulture].MemberPermission_CanManageProjectMembers || langMap.en.MemberPermission_CanManageProjectMembers;
    },
    get MemberPermission_CanManageProjectMembersAndAllocations() {
        return langMap[ep.resxCulture].MemberPermission_CanManageProjectMembersAndAllocations || langMap.en.MemberPermission_CanManageProjectMembersAndAllocations;
    },
    get MemberPermission_CanViewAllExpenses() {
        return langMap[ep.resxCulture].MemberPermission_CanViewAllExpenses || langMap.en.MemberPermission_CanViewAllExpenses;
    },
    get MemberPermission_CanViewMembersAndAssignees() {
        return langMap[ep.resxCulture].MemberPermission_CanViewMembersAndAssignees || langMap.en.MemberPermission_CanViewMembersAndAssignees;
    },
    get MemberPermission_Delete() {
        return langMap[ep.resxCulture].MemberPermission_Delete || langMap.en.MemberPermission_Delete;
    },
    get MemberPermission_Delete_All() {
        return langMap[ep.resxCulture].MemberPermission_Delete_All || langMap.en.MemberPermission_Delete_All;
    },
    get MemberPermission_Delete_Or_Archive() {
        return langMap[ep.resxCulture].MemberPermission_Delete_Or_Archive || langMap.en.MemberPermission_Delete_Or_Archive;
    },
    get MemberPermission_Edit() {
        return langMap[ep.resxCulture].MemberPermission_Edit || langMap.en.MemberPermission_Edit;
    },
    get MemberPermission_Edit_All() {
        return langMap[ep.resxCulture].MemberPermission_Edit_All || langMap.en.MemberPermission_Edit_All;
    },
    get MemberPermission_Edit_Assigned() {
        return langMap[ep.resxCulture].MemberPermission_Edit_Assigned || langMap.en.MemberPermission_Edit_Assigned;
    },
    get MemberPermission_Manage_Assigned() {
        return langMap[ep.resxCulture].MemberPermission_Manage_Assigned || langMap.en.MemberPermission_Manage_Assigned;
    },
    get MemberPermission_View_All() {
        return langMap[ep.resxCulture].MemberPermission_View_All || langMap.en.MemberPermission_View_All;
    },
    get MemberPermission_View_and_Manage() {
        return langMap[ep.resxCulture].MemberPermission_View_and_Manage || langMap.en.MemberPermission_View_and_Manage;
    },
    get MemberPermission_View_Assigned() {
        return langMap[ep.resxCulture].MemberPermission_View_Assigned || langMap.en.MemberPermission_View_Assigned;
    },
    get MemberPermissions_ExpensesTitle() {
        return langMap[ep.resxCulture].MemberPermissions_ExpensesTitle || langMap.en.MemberPermissions_ExpensesTitle;
    },
    get MemberPermissions_MembersAndAssigneesTitle() {
        return langMap[ep.resxCulture].MemberPermissions_MembersAndAssigneesTitle || langMap.en.MemberPermissions_MembersAndAssigneesTitle;
    },
    get MemberPermissions_TasksTitle() {
        return langMap[ep.resxCulture].MemberPermissions_TasksTitle || langMap.en.MemberPermissions_TasksTitle;
    },
    get MemberPermissions_ThisProjectTitle() {
        return langMap[ep.resxCulture].MemberPermissions_ThisProjectTitle || langMap.en.MemberPermissions_ThisProjectTitle;
    },
    get MemberPermissions_TimeEntriesTitle() {
        return langMap[ep.resxCulture].MemberPermissions_TimeEntriesTitle || langMap.en.MemberPermissions_TimeEntriesTitle;
    },
    get Members() {
        return langMap[ep.resxCulture].Members || langMap.en.Members;
    },
    get no_assignee() {
        return langMap[ep.resxCulture].no_assignee || langMap.en.no_assignee;
    },
    get On() {
        return langMap[ep.resxCulture].On || langMap.en.On;
    },
    get OwnBudget() {
        return langMap[ep.resxCulture].OwnBudget || langMap.en.OwnBudget;
    },
    get PercentDone() {
        return langMap[ep.resxCulture].PercentDone || langMap.en.PercentDone;
    },
    get PermissionsSettingsTitle() {
        return langMap[ep.resxCulture].PermissionsSettingsTitle || langMap.en.PermissionsSettingsTitle;
    },
    get project() {
        return langMap[ep.resxCulture].project || langMap.en.project;
    },
    get Project_NotFound_Message() {
        return langMap[ep.resxCulture].Project_NotFound_Message || langMap.en.Project_NotFound_Message;
    },
    get Project_NotFound_Title() {
        return langMap[ep.resxCulture].Project_NotFound_Title || langMap.en.Project_NotFound_Title;
    },
    get Project_WasCompleted_Ok() {
        return langMap[ep.resxCulture].Project_WasCompleted_Ok || langMap.en.Project_WasCompleted_Ok;
    },
    get Project_WasCompleted_Trouble() {
        return langMap[ep.resxCulture].Project_WasCompleted_Trouble || langMap.en.Project_WasCompleted_Trouble;
    },
    get Project_WasCompleted_Warning() {
        return langMap[ep.resxCulture].Project_WasCompleted_Warning || langMap.en.Project_WasCompleted_Warning;
    },
    get RatioOfMoneySpent() {
        return langMap[ep.resxCulture].RatioOfMoneySpent || langMap.en.RatioOfMoneySpent;
    },
    get RepeatActivity() {
        return langMap[ep.resxCulture].RepeatActivity || langMap.en.RepeatActivity;
    },
    get request() {
        return langMap[ep.resxCulture].request || langMap.en.request;
    },
    get ResumeWorkHelpText() {
        return langMap[ep.resxCulture].ResumeWorkHelpText || langMap.en.ResumeWorkHelpText;
    },
    get ResumeWorkText() {
        return langMap[ep.resxCulture].ResumeWorkText || langMap.en.ResumeWorkText;
    },
    get RoleTitle() {
        return langMap[ep.resxCulture].RoleTitle || langMap.en.RoleTitle;
    },
    get Save() {
        return langMap[ep.resxCulture].Save || langMap.en.Save;
    },
    get Set_actualCompletionDate() {
        return langMap[ep.resxCulture].Set_actualCompletionDate || langMap.en.Set_actualCompletionDate;
    },
    get Set_budget() {
        return langMap[ep.resxCulture].Set_budget || langMap.en.Set_budget;
    },
    get Set_categoryId() {
        return langMap[ep.resxCulture].Set_categoryId || langMap.en.Set_categoryId;
    },
    get Set_customerId() {
        return langMap[ep.resxCulture].Set_customerId || langMap.en.Set_customerId;
    },
    get Set_dates() {
        return langMap[ep.resxCulture].Set_dates || langMap.en.Set_dates;
    },
    get Set_description() {
        return langMap[ep.resxCulture].Set_description || langMap.en.Set_description;
    },
    get Set_endDate() {
        return langMap[ep.resxCulture].Set_endDate || langMap.en.Set_endDate;
    },
    get Set_estimatedHours() {
        return langMap[ep.resxCulture].Set_estimatedHours || langMap.en.Set_estimatedHours;
    },
    get Set_hoursLeft() {
        return langMap[ep.resxCulture].Set_hoursLeft || langMap.en.Set_hoursLeft;
    },
    get Set_labor_budget() {
        return langMap[ep.resxCulture].Set_labor_budget || langMap.en.Set_labor_budget;
    },
    get Set_portfolioId() {
        return langMap[ep.resxCulture].Set_portfolioId || langMap.en.Set_portfolioId;
    },
    get Set_short_hoursLeft() {
        return langMap[ep.resxCulture].Set_short_hoursLeft || langMap.en.Set_short_hoursLeft;
    },
    get SetAsRootLevel() {
        return langMap[ep.resxCulture].SetAsRootLevel || langMap.en.SetAsRootLevel;
    },
    get SetCompleted() {
        return langMap[ep.resxCulture].SetCompleted || langMap.en.SetCompleted;
    },
    get short_hoursLeft() {
        return langMap[ep.resxCulture].short_hoursLeft || langMap.en.short_hoursLeft;
    },
    get show_checklist_label() {
        return langMap[ep.resxCulture].show_checklist_label || langMap.en.show_checklist_label;
    },
    get ShowCustomFields() {
        return langMap[ep.resxCulture].ShowCustomFields || langMap.en.ShowCustomFields;
    },
    get Spent() {
        return langMap[ep.resxCulture].Spent || langMap.en.Spent;
    },
    get Status() {
        return langMap[ep.resxCulture].Status || langMap.en.Status;
    },
    get task() {
        return langMap[ep.resxCulture].task || langMap.en.task;
    },
    get Task_NotFound_Message() {
        return langMap[ep.resxCulture].Task_NotFound_Message || langMap.en.Task_NotFound_Message;
    },
    get Task_NotFound_Title() {
        return langMap[ep.resxCulture].Task_NotFound_Title || langMap.en.Task_NotFound_Title;
    },
    get Task_WasCompleted_Ok() {
        return langMap[ep.resxCulture].Task_WasCompleted_Ok || langMap.en.Task_WasCompleted_Ok;
    },
    get Task_WasCompleted_Trouble() {
        return langMap[ep.resxCulture].Task_WasCompleted_Trouble || langMap.en.Task_WasCompleted_Trouble;
    },
    get Task_WasCompleted_Warning() {
        return langMap[ep.resxCulture].Task_WasCompleted_Warning || langMap.en.Task_WasCompleted_Warning;
    },
    get today() {
        return langMap[ep.resxCulture].today || langMap.en.today;
    },
    get UnFollow() {
        return langMap[ep.resxCulture].UnFollow || langMap.en.UnFollow;
    },
    get unfollow_all_activities_label() {
        return langMap[ep.resxCulture].unfollow_all_activities_label || langMap.en.unfollow_all_activities_label;
    },
    get WindowUnload_UnsavedChanges() {
        return langMap[ep.resxCulture].WindowUnload_UnsavedChanges || langMap.en.WindowUnload_UnsavedChanges;
    },
};

// @ts-ignore
ep.resources = ep.resources || {};

// @ts-ignore
ep.resources.taskDetails = taskDetailsResx;
